export const ARTWORKS = [
  {
    id: 'the-fire',
    title: 'The Fire',
    titleHe: 'האש',
    subtitle: 'Sacred Fire Collection',
    description: 'A living flame — sacred, eternal, untamed. This work captures the dual nature of sacred fire: both destroyer and purifier, both primal terror and divine grace. The flame rises from darkness as a testament to inner truth.',
    descriptionFr: "Une flamme vivante — sacrée, éternelle, indomptée. Cette œuvre saisit la double nature du feu sacré : à la fois destructeur et purificateur, terreur primale et grâce divine. La flamme s'élève des ténèbres comme témoignage de la vérité intérieure.",
    spiritual: 'Where fire burns, the Divine speaks without words.',
    spiritualFr: 'Là où le feu brûle, le Divin parle sans mots.',
    collection: 'Inner Flame',
    imageUrl: '/artworks/the-fire-opt.jpg',
    dimensions: '100 × 100 cm',
    medium: 'Plexiglas high resolution',
    mediumFr: 'Plexiglas haute résolution',
    uniquePrice: 3300,
    printFormat: 'square',
    wall: 'left',
    z: 11,
    width: 4.5,
    height: 4.5,
    avatarTargetX: -4.2,
    avatarTargetZ: 11,
    avatarTargetYaw: Math.PI / 2,
  },
  {
    id: 'souffle-de-vie',
    title: 'Souffle de Vie',
    titleHe: 'נשמת חיים',
    subtitle: 'Breath of Life',
    description: "An exploration of divine light crossing spiritual dimensions, revealing the inner flame guiding each soul toward its truth. Matter and spirit unite in this ascending movement.",
    descriptionFr: "Une exploration de la lumière divine qui traverse les dimensions spirituelles, révélant la flamme intérieure qui guide chaque âme vers sa vérité. La matière et l'esprit s'unissent dans ce mouvement ascendant.",
    spiritual: "The soul is a flame hidden in matter, waiting to be revealed.",
    spiritualFr: "L'âme est une flamme cachée dans la matière, attendant d'être révélée.",
    collection: 'Divine Light',
    imageUrl: '/artworks/souffle-de-vie-opt.jpg',
    dimensions: '100 × 100 cm',
    medium: "Mixed media & gold leaf on canvas",
    mediumFr: "Techniques mixtes & feuille d'or sur toile",
    uniquePrice: 3700,
    uniqueLabel: 'Pièce Exclusive',
    printFormat: 'square',
    wall: 'right',
    z: 7,
    width: 4.5,
    height: 4.5,
    avatarTargetX: 4.2,
    avatarTargetZ: 7,
    avatarTargetYaw: -Math.PI / 2,
    contextImages: [
      'https://customer-assets.emergentagent.com/job_kedoucha-immersive/artifacts/3t28sut3_53PD5HuxSLS4el6qMxmpYver.png',
      'https://customer-assets.emergentagent.com/job_kedoucha-immersive/artifacts/l77u649q_fhzjOe8zQOSprbBTCKm3Tfez.png',
    ],
  },
  {
    id: 'un-echange-ardent',
    title: 'Un Échange Ardent',
    titleHe: 'חילופין לוהטים',
    subtitle: 'The Ardent Exchange',
    description: "An ardent tree rises from the cracked desert — its flames do not burn, they transmit. The human presence in the distance is not a witness, it is an interlocutor. This exchange has no words; it has a direction. Upward.",
    descriptionFr: "Un arbre ardent s'élève du désert fendu — ses flammes ne brûlent pas, elles transmettent. La présence humaine au loin n'est pas témoin, elle est interlocuteur. Cet échange n'a pas de mots ; il a une direction. Vers le Haut.",
    spiritual: "Where matter burns without being consumed, the Divine presence is revealed.",
    spiritualFr: "Là où la matière brûle sans se consumer, la présence Divine se révèle.",
    collection: 'Sacred Dialogue',
    imageUrl: '/artworks/un-echange-ardent-opt.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Oil painting, handcrafted',
    mediumFr: "Peinture à l'huile fait main",
    uniquePrice: 2700,
    printFormat: 'vertical',
    wall: 'left',
    z: 2,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: -3.6,
    avatarTargetZ: 2,
    avatarTargetYaw: Math.PI / 2,
  },
  {
    id: 'lenvoy',
    title: "L'Envoyé",
    titleHe: 'השליח',
    subtitle: 'The Messenger · Sacred Presence',
    description: "The Rabbi stands in momentum. The tallit opens like a wing, extending the body upward. The gesture is not symbolic — it is direction. It traces a line between here and the beyond. In the Lubavitch spirit, spirituality does not withdraw from the world — it engages with it.",
    descriptionFr: "Le Rabbi se tient dans l'élan. Le talit s'ouvre comme une aile, prolongeant le corps vers le haut. Le geste n'est pas symbolique : il est direction. Il trace une ligne entre ici et l'au-delà. Dans l'esprit Lubavitch, la spiritualité ne se retire pas du monde — elle s'y engage.",
    spiritual: 'In this single gesture, the boundary between earth and heaven dissolves.',
    spiritualFr: "Dans ce seul geste, la frontière entre la terre et le ciel se dissout.",
    collection: 'Sacred Presence',
    imageUrl: '/artworks/lenvoy-opt.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Oil painting, handcrafted',
    mediumFr: "Peinture à l'huile fait main",
    uniquePrice: 3399,
    printFormat: 'vertical',
    contextImages: [
      '/artworks/lenvoy-context.jpg',
    ],
    wall: 'right',
    z: -3,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: 3.6,
    avatarTargetZ: -3,
    avatarTargetYaw: -Math.PI / 2,
  },
  {
    id: 'la-benediction',
    title: 'La Bénédiction Vivante',
    titleHe: 'הברכה החיה',
    subtitle: 'The Living Blessing · Eternal Foundations',
    description: "Baba Salé is captured in a simple moment: a bottle wrapped in cloth, a glass, a calm hand. Matter seemed to obey another law. The gaze of the tzaddik transforms the object into a source. What was meant to end... remains.",
    descriptionFr: "Baba Salé est saisi dans un instant simple : une bouteille entourée d'un linge, un verre, une main calme. La matière semblait obéir à une autre loi. Le regard du tsaddik transforme l'objet en source. Ce qui devait finir... demeure.",
    spiritual: 'Where the gaze of holiness falls, the ordinary becomes a vessel of the eternal.',
    spiritualFr: "Là où se pose le regard de la sainteté, l'ordinaire devient vase de l'éternel.",
    collection: 'Eternal Foundations',
    imageUrl: '/artworks/la-benediction-opt.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Oil painting, handcrafted',
    mediumFr: "Peinture à l'huile fait main",
    uniquePrice: 3399,
    printFormat: 'vertical',
    contextImages: [
      '/artworks/la-benediction-context.jpg',
    ],
    wall: 'left',
    z: -8,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: -3.6,
    avatarTargetZ: -8,
    avatarTargetYaw: Math.PI / 2,
  },
  {
    id: 'feu-pierre',
    title: 'Un Feu emprisonné dans la Pierre',
    titleHe: 'אש כלואה באבן',
    subtitle: 'Sacred Fire in Stone',
    description: "Matter seems frozen, almost silent — and yet, a crack opens. A golden fissure, fine, almost imperceptible, crosses the stone and rises, reaching toward the Divine Presence. Like a call. Like an origin.",
    descriptionFr: "La matière semble figée, presque silencieuse — et pourtant, une fissure s'ouvre. Une brisure dorée, fine, presque imperceptible, traverse la pierre et s'élève, tendant vers la Présence Divine. Comme un appel. Comme une origine.",
    spiritual: "It is often in the crack that light begins.",
    spiritualFr: "C'est souvent dans la faille que commence la lumière. La présence ne s'impose pas — elle apparaît là où quelque chose s'est ouvert.",
    collection: 'Eternal Foundations',
    imageUrl: '/artworks/feu-pierre-correct.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Mixed media on textured canvas',
    mediumFr: 'Techniques mixtes sur toile texturée',
    uniquePrice: 2774,
    printFormat: 'vertical',
    contextImages: [
      '/artworks/feu-pierre-context.jpg',
    ],
    wall: 'right',
    z: -13,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: 3.6,
    avatarTargetZ: -13,
    avatarTargetYaw: -Math.PI / 2,
  },
  {
    id: 'entre-harpe-epee',
    title: 'Entre Harpe et Épée',
    titleHe: 'בין נבל לחרב',
    subtitle: "David HaMelekh · L'Origine du Mouvement",
    description: "Tradition evokes a harp whose strings, even abandoned by the hand of David HaMelekh, continued to vibrate under the effect of an invisible breath — a breath that does not come from man, but from above. Here, music becomes presence. Strength and gentleness no longer oppose each other — they unite.",
    descriptionFr: "La tradition évoque une harpe dont les cordes, même abandonnées par la main de David HaMelekh, continuaient de vibrer sous l'effet d'un souffle invisible. Un souffle qui ne vient pas de l'homme, mais de plus haut. Ici, la musique devient présence. La force et la douceur ne s'opposent plus — elles s'unissent.",
    spiritual: "True strength is not that which cuts — it is that which sings.",
    spiritualFr: "La vraie force n'est pas celle qui tranche — c'est celle qui chante.",
    collection: 'Sacred Dialogue',
    imageUrl: '/artworks/entre-harpe-epee-opt.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Oil painting, handcrafted',
    mediumFr: "Peinture à l'huile fait main",
    uniquePrice: 3556,
    printFormat: 'vertical',
    contextImages: [
      '/artworks/entre-harpe-context.jpg',
    ],
    wall: 'left',
    z: -18,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: -3.6,
    avatarTargetZ: -18,
    avatarTargetYaw: Math.PI / 2,
  },
  {
    id: 'already-done',
    title: 'Already Done',
    titleHe: 'כְּבָר נַעֲשָׂה',
    subtitle: 'Déjà Accompli · David & le Lion',
    description: "David stands facing the lion. Nothing protects him except what cannot be seen. The staff is not raised to strike. It rises. The gesture is not a reaction — it is alignment. In the tradition of David, strength does not come from the body, but from what one is connected to. The lion roars. The danger is real. And yet, something is already in place. This moment is not the beginning of a fight. It is the manifestation of a decision already made elsewhere.",
    descriptionFr: "David se tient face au lion. Rien ne le protège, sinon ce qui ne se voit pas. Le bâton ne sert pas à frapper. Il s'élève. Le geste n'est pas une réaction — c'est un alignement. Dans la tradition de David, la force ne vient pas du corps, mais de ce à quoi l'on est relié. Le lion rugit. Le danger est réel. Et pourtant, quelque chose est déjà en place. Ce moment n'est pas le début d'un combat. C'est la manifestation d'une décision déjà accomplie ailleurs.",
    spiritual: "This piece is not meant to be understood. It's meant to be felt.",
    spiritualFr: "Cette œuvre n'est pas faite pour être comprise. Elle est faite pour être ressentie.",
    collection: 'Sacred Courage',
    imageUrl: '/artworks/already-done-opt.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Oil painting, handcrafted',
    mediumFr: "Peinture à l'huile fait main",
    uniquePrice: 2900,
    printFormat: 'vertical',
    wall: 'right',
    z: -22,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: 3.6,
    avatarTargetZ: -22,
    avatarTargetYaw: -Math.PI / 2,
  },
  // ─── Ajout 1 : Le Veilleur — Mur GAUCHE, espacé 9 unités d'Entre Harpe ───
  {
    id: 'le-veilleur',
    title: 'Le Veilleur',
    titleHe: 'הַשּׁוֹמֵר',
    subtitle: 'Portrait Spirituel · Sacred Presence',
    description: "A gaze that pierces through the visible to reach the soul. In the silence of the face and the depth of the eyes, manifests the presence of a guide — an awakened consciousness turned toward the invisible. The Rabbi's gaze does not judge: it watches. It descends into the soul like a discreet light, carrying within it memory, discernment, and mercy.",
    descriptionFr: "Un regard qui traverse le visible pour atteindre l'âme. Dans le silence du visage et la profondeur des yeux, se manifeste la présence d'un guide, d'une conscience éveillée tournée vers l'invisible. Le regard du Rabbi ne juge pas : il veille. Il descend dans l'âme comme une lumière discrète, portant en lui la mémoire, l'exigence et la miséricorde.",
    spiritual: "The gaze of the watchman illuminates without exposing, guides without constraining.",
    spiritualFr: "Le regard du veilleur éclaire sans exposer, guide sans contraindre.",
    collection: 'Sacred Presence',
    imageUrl: '/artworks/le-veilleur-opt.jpg',
    dimensions: '60 × 90 cm',
    medium: 'Acrylic on canvas, handcrafted',
    mediumFr: 'Acrylique sur toile, peinture fait main',
    uniquePrice: 2770,
    printFormat: 'vertical',
    contextImages: ['https://customer-assets.emergentagent.com/job_kedoucha-immersive/artifacts/lhb03fww_upscalemedia-transformed%20%288%29.jpeg', '/artworks/le-veilleur-detail.mp4'],
    wall: 'left',
    z: -27,
    width: 4.1,
    height: 5.1,
    yPos: 5.0,
    avatarTargetX: -3.8,
    avatarTargetZ: -27,
    avatarTargetYaw: Math.PI / 2,
  },
  // ─── Ajout 3 : Rabbi Shimon Bar Yo'haï — Mur GAUCHE, espacé 9 unités de Le Veilleur ───
  {
    id: 'rabbi-shimon',
    title: "Rabbi Shimon Bar Yo'haï",
    titleHe: 'רַבִּי שִׁמְעוֹן בַּר יוֹחַאי',
    subtitle: 'Le Dévoilement · Passeur de Lumière',
    description: "Rabbi Shimon Bar Yo'haï is caught in the very moment when the hidden becomes legible. The parchment in his hands is not merely a surface — it is a breach in the fabric of the world. The one who transmitted the Zohar appears here not as a scholar, but as a bridge between two planes of reality. The golden splashes do not decorate the canvas — they signal an opening in matter itself, where sacred light presses through. This painting does not show a man writing. It shows a world allowing itself to be revealed.",
    descriptionFr: "Rabbi Shimon Bar Yo'haï est saisi à l'instant même où le caché devient lisible. Le parchemin qu'il tient n'est pas un simple support — c'est une brèche ouverte dans le tissu du monde. Celui qui transmit le Zohar n'apparaît pas ici comme un savant, mais comme un passeur entre deux plans de réalité. Les éclats d'or ne décorent pas la toile — ils signalent une ouverture dans la matière elle-même, là où la lumière secrète cherche à sortir. Ce tableau ne montre pas un homme qui écrit. Il montre un monde qui se laisse révéler.",
    spiritual: "What was veiled from the beginning is revealed when the hand that writes is guided by Ein-Sof.",
    spiritualFr: "Ce qui était voilé depuis le commencement se révèle lorsque la main qui écrit est guidée par l'En-Sof.",
    collection: 'Sacred Presence',
    imageUrl: '/artworks/rabbi-shimon-opt.jpg',
    dimensions: '90 × 120 cm',
    medium: 'Mixed media — oil & gold leaf, handcrafted',
    mediumFr: "Techniques mixtes — huile et feuille d'or sur toile, fait main",
    uniquePrice: 3200,
    printFormat: 'vertical',
    contextImages: ['/artworks/rabbi-shimon-context-opt.jpg'],
    wall: 'left',
    z: -36,
    width: 5.0625,
    height: 6.75,
    yPos: 5.2,
    avatarTargetX: -3.6,
    avatarTargetZ: -36,
    avatarTargetYaw: Math.PI / 2,
  },
  // ─── Ajout 2 : Sous la Présence — Mur DROIT, espacé 9 unités d'Already Done ───
  {
    id: 'sous-la-presence',
    title: 'Sous la Présence',
    titleHe: 'תַּחַת הַשְּׁכִינָה',
    subtitle: 'Une Origine · Sacred Union',
    description: "This work captures the moment two souls become a beginning. The Rabbi's wedding is not depicted as an event, but as an origin: the point where a new life takes root in the world. The gilded touches are not ornaments — they descend upon the scene as a discreet imprint of the Presence. Everything is restrained, almost silent, and yet everything begins.",
    descriptionFr: "Cette œuvre saisit l'instant où deux âmes deviennent un commencement. Le mariage du Rabbi n'est pas représenté comme un événement, mais comme une origine : le point où une vie nouvelle prend racine dans le monde. Les dorures ne sont pas des ornements ; elles descendent dans la scène comme une empreinte discrète de la Présence. Tout est retenu, presque silencieux, et pourtant tout commence.",
    spiritual: "Every union consecrated in holiness is an echo of the first creation.",
    spiritualFr: "Toute union consacrée dans le sacré est un écho de la première création.",
    collection: 'Sacred Union',
    imageUrl: '/artworks/sous-la-presence-opt.jpg',
    dimensions: '60 × 120 cm',
    medium: "Oil & gold leaf on canvas, handcrafted",
    mediumFr: "Huile et feuille d'or sur toile, peinture fait main",
    uniquePrice: 3077,
    printFormat: 'horizontal-custom',
    contextImages: ['/artworks/sous-la-presence-context-opt.jpg'],
    wall: 'right',
    z: -32,
    width: 7.5,
    height: 3.75,
    yPos: 5.2,
    avatarTargetX: 4.2,
    avatarTargetZ: -32,
    avatarTargetYaw: -Math.PI / 2,
    mobileAvatarTargetX: 1.8,
  },
];
